import { PaysafeAccounts } from './paysafe-accounts.interface';
import { PaysafeFieldsConfig } from './paysafe-fields-config.interface';
import { PaysafeStyle } from './paysafe-style.type';

export interface PaysafeSetupOptions {
  currencyCode?: string;
  accounts?: PaysafeAccounts;
  environment?: string;
  fields: PaysafeFieldsConfig;
  style?: PaysafeStyle;
}
